import {computed, observable} from "mobx";
import {MobXHelper, VarHelper} from "common-import/helpers";
import api from "./Project.API";

const { makePersit } = MobXHelper;

const PERSIST_STORE_ITEM = {

};

class ProjectStore {
  @observable listApproved = [];

  @observable listNotApproved = [];

  @observable listAnswer = [];

  @observable currentProject = {};

  @observable currentAnswer = {};

  @computed get allListProject() {
    return [...this.listApproved, ...this.listNotApproved];
  }

  setProp = (prop, value) => { this[prop] = value  };

  getAll = async (page) => {
    let res = await api.adminList({
      "orderBy": "updatedAt",
      "orderType": "DESC",
      "page": page || 1
    });
    let json = await res.json();
    if (!!json.error) return { status: false, error: json.error };
    this.listApproved = json.data;
    return { status: true };
  };

  getListApproved = async (page) => {
    let res = await api.adminList({
      "orderBy": "updatedAt",
	    "orderType": "DESC",
      "approved": 1,
      "page": page || 1
    });
    let json = await res.json();
    if(!!json.error) return { status: false, error: json.error };
    this.listApproved = json.data;
    return { status: true };
  };

  getListNotApproved = async (page) => {
    let res = await api.adminList({
      "orderBy": "updatedAt",
	    "orderType": "DESC",
      "approved": 0,
      "page": page || 1
    });
    let json = await res.json();
    if(!!json.error) return { status: false, error: json.error };
    this.listNotApproved = json.data;
    return { status: true };
  };

  getListNotApprovedUpdate = async (page) => {
    let res = await api.adminList({
      "orderBy": "updatedAt",
	    "orderType": "DESC",
      "approved": 3,
      "page": page || 1
    });
    let json = await res.json();
    if(!!json.error) return { status: false, error: json.error };
    this.listNotApproved = json.data;
    return { status: true };
  };

  search = async (name, approved) => {
    let res = await api.adminList({
      "name": name,
      "orderBy": "updatedAt",
	    "orderType": "DESC",
	    "approved": approved ? 1 : 0,
    });
    let json = await res.json();
    if(!!json.error) return { status: false, error: json.error };
    if(approved) {
      this.listApproved = json.data;
    } else {
      this.listNotApproved = json.data;
    }
    return { status: true };
  };

  getProjectDetail = async id => {
    const res = await api.detail(id);
    const json = await res.json();
    this.currentProject = VarHelper.cloneDeep(json.data);
    return json.data;
  };

  update = async data => {
    const { id } = this.currentProject;
    if (!id) return;
    const res = await api.update(id, data);
    if (res.validateError) {
      return { error: res.validateError };
    }
    return await res.json();
  };

  create = async data => {
    let res = await api.create(data);
    if (!!res.validateError) {
      return { error: res.validateError }
    }
    return await res.json();
  };

  approve = async ({ id, approved }) => {
    const res = await api.approve({ id, approved: approved ? 1 : 0});
    if (!!res.validateError) {
      return { error: res.validateError };
    }
    return await res.json();
  };

  deactive = async (id) => {
    const res = await api.deactive({id});
    if (!!res.validateError) {
      return { error: res.validateError };
    }
    return await res.json();
  };

  getListAnswer = async (page) => {
    const res = await api.adminListAnswers({page: page || 1});
    if (!!res.validateError) {
      return { error: res.validateError };
    }
    const json = await res.json();
    if (!json.error) this.listAnswer = VarHelper.cloneDeep(json.data);
    return json;
  };

  answerDetail = (id) => {
    this.currentAnswer = this.listAnswer.find(item => item.id === id);
  };
}

const projectStore = new ProjectStore();

export default projectStore;



// WEBPACK FOOTER //
// ./src/services/project/Project.Store.js